import { makeNewField } from '@icp/form-designer';
import { parseJSON } from '@icp/utils';

export async function transformToGenericEChartElement(input) {
  try {
    input = parseJSON(input, { silent: true, autocomplete: true });
    if (!input) return null;
    if (!input.url) return null;

    const newField = makeNewField('GenericEChart');

    newField.componentProps.dataUrl = input.url;
    newField.componentProps.dataResponseKeyPath = '';

    return [newField, input.title];
  } catch {
    return null;
  }
}
